import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { CalendarMinus2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ChatBannerImage from 'assets/home/SESION-PSICOLOGICA-IMG.webp';
import { Banner } from 'components/ui/Banner';
import { ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';

interface AppointmentsBannerProps {
  className?: string;
  hideImage?: boolean;
}

export const AppointmentsBanner = ({
  className,
  hideImage = false,
}: AppointmentsBannerProps): React.ReactElement => {
  const patient = useUserStore(state => state.user);
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  const handleOnClick = (): void => {
    if (patient && !patient.profileCompleteToBookAppointments) {
      navigate(ROUTES.APPOINTMENTS_PERSONAL_DATA);
      return;
    }
    navigate(ROUTES.APPOINTMENTS_RESERVE);
  };

  return (
    <Banner
      className={cn('am-lg:p-0 p-0', className)}
      title={t('AppointmentsBanner.heading')}
      description={t('AppointmentsBanner.empty')}
      {...(!hideImage && { image: ChatBannerImage })}
      icon={CalendarMinus2}
      buttonProps={{
        variant: 'secondary',
        label: t('AppointmentsReserve.cta'),
        onClick: handleOnClick,
      }}
    />
  );
};
